import React from "react";
import "../css/healthnews.css";
import Navbar from "../Navbar";

export default function HealthCare3() {
  return (
    <>
      <Navbar />
      <div className="container" id="white">
        {/* Main Article */}
        <article className="main-article" id="orange">
          <div className="grid-layout">
            {/* Main Content */}
            <div className="main-content">
              {/* Featured Article */}
              <div className="featured-articl">
               
                  <img
                    src="./images/Fatah-Hamas.jpg"
                    alt="Business people in a hallway"
                    className="featured-image"
                  />
                
                
                  <h1>Fatah-Hamas Reconciliation Progress</h1>
                

                <div className="author-info">
                  <span>By Kelly Phillips Erb</span>
                  <span className="separator">|</span>
                  <span>EI Staff</span>
                </div>
                <div className="news-showcase">
                  <p>
                    {" "}
                    Palestinian factions Fatah and Hamas near an agreement to
                    form a technocratic governing body for Gaza, signaling
                    potential political unity post-Israel-Hamas war.
                  </p>
                </div>
              </div>
              {/* Secondary Articles Grid */}
              <div className="secondary-articles">
                {/* Article 1 */}
                <div className="articl">
                  <a href="#">
                    <img src="./images/trump.png" alt="Capitol building" />
                  </a>
                  <a href="#" className="anchor">
                    <h2>
                      With A Government Shutdown Deadline Looming, IRS Funding
                      Hangs In The Balance
                    </h2>
                  </a>
                  <div className="author-info">
                    By Kelly Phillips Erb | TSD Staff
                  </div>
                </div>
                {/* Article 2 */}
                <div className="articl">
                  <a href="#">
                    <img src="./images/trump.png" alt="Stock market data" />
                  </a>
                  <a href="#" className="anchor">
                    <h2>
                      America's Top 100 Mid-Cap Stocks: Meet The Companies
                      Powering The AI Boom
                    </h2>
                  </a>

                  <div className="author-info">By Hank Tucker | TSD Staff</div>
                </div>
              </div>
            </div>
            {/* Sidebar */}
            <aside className="sidebar">
              {/* Sidebar Article 1 */}
              <div className="sidebar-article">
                <a href="#">
                  <img src="./images/trump.png" alt="Tax document review" />
                </a>
                <a href="#" className="anchor">
                  <h2>We Need A Big, Fat Tax Cut Fast</h2>
                </a>
                <div className="author-info">By Steve Forbes | TSD Staff</div>
              </div>
              {/* Sidebar Article 2 */}
              <div className="sidebar-articl">
                <a href="#">
                  <img src="./images/trump.png" alt="Small business owner" />
                </a>
                <a href="#" className="anchor">
                  <h2>
                    How A New SBA Lending Rule Gives Buyers The Chance To Cut
                    Deals Like Private Equity Pros
                  </h2>
                </a>

                <div className="author-info">
                  By Brandon Kochkodin | TSD Staff
                </div>
              </div>
              <div className="sidebar-articl">
                <a href="#">
                  <img src="./images/trump.png" alt="Small business owner" />
                </a>
                <a href="#" className="anchor">
                  <h2>
                    How A New SBA Lending Rule Gives Buyers The Chance To Cut
                    Deals Like Private Equity Pros
                  </h2>
                </a>

                <div className="author-info">
                  By Brandon Kochkodin | TSD Staff
                </div>
              </div>
              <div className="sidebar-articl">
                <a href="#">
                  <img src="./images/trump.png" alt="Small business owner" />
                </a>
                <a href="#" className="anchor">
                  <h2>
                    How A New SBA Lending Rule Gives Buyers The Chance To Cut
                    Deals Like Private Equity Pros
                  </h2>
                </a>

                <div className="author-info">
                  By Brandon Kochkodin | TSD Staff
                </div>
              </div>
            </aside>
          </div>
        </article>
      </div>
    </>
  );
}
